export default {
    breadcrumbs: {
        home: 'Главная',
        contact: 'Контакты',
    },
    heading: 'Страница контактов',
    contact: 'Связаться',
    contact_us: 'Свяжитесь с нами',
    description_1: 'Нам всегда приятно получать от вас отклик.',
    description_2:
        'Заполните форму справа, и мы ответим вам как можно скорее. В рабочее время ожидайте ответа в течение 24 часов.',
    description_3:
        'Если проблема не может ждать так долго, не волнуйтесь! Мы посвящены своему делу и доступны во внерабочее время для чрезвычайных ситуаций.',
    phone: 'Телефон',
    email: 'Электронная почта',
    address: 'Записаться на встречу',
    support: 'Schedule a meeting',
}
